export default __webpack_public_path__ + "static/media/product17_sportshoe.1565794e.webp";